import { Sparkles, Mail, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#064E3B] text-white">
      <div className="container-x py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <div className="h-9 w-9 rounded-xl bg-[#F59E0B] flex items-center justify-center">
              <Sparkles className="h-5 w-5 text-[#064E3B]" />
            </div>
            <span className="font-display font-black text-lg">5GB Corporation</span>
          </div>
          <p className="mt-4 text-sm text-[#D6D3D1] max-w-md">
            Building India's largest home-based distributor network for everyday home care essentials.
          </p>
        </div>

        <div>
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#F59E0B]">Contact</div>
          <div className="mt-4 space-y-3 text-sm">
            <a href="tel:+919974993396" data-testid="footer-phone" className="flex items-center gap-2 hover:text-[#F59E0B]">
              <Phone className="h-4 w-4"/> +91 99749 93396
            </a>
            <a href="https://wa.me/919974993396" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2 hover:text-[#F59E0B]">
              <Phone className="h-4 w-4"/> WhatsApp: +91 99749 93396
            </a>
            <a href="mailto:sales@5gb.in" data-testid="footer-email" className="flex items-center gap-2 hover:text-[#F59E0B]">
              <Mail className="h-4 w-4"/> sales@5gb.in
            </a>
          </div>
        </div>

        <div>
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#F59E0B]">Quick links</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href="#how" className="hover:text-[#F59E0B]">How it works</a></li>
            <li><a href="#products" className="hover:text-[#F59E0B]">Products</a></li>
            <li><a href="#calculator" className="hover:text-[#F59E0B]">Earnings calculator</a></li>
            <li><a href="#register" className="hover:text-[#F59E0B]">Register</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-5 text-xs text-[#A8A29E] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} 5GB Corporation. All rights reserved.</span>
          <span>Made with care for home entrepreneurs.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
